(function($) {

	$.fn.initTabContainer = function(defaultTabId) {

		return this.each(function() {

			var $this = $(this);
			var thisHeight = $this.find(".tabs").outerHeight(true);
			
			$this.find(".tabs a[data-id='" + defaultTabId + "']").addClass("active");
			$this.find(".contents .tab-contents[data-id='" + defaultTabId + "']").addClass("active");

			$this.find(".tabs a").click(function() {
				var oldTab = $this.find(".tabs a.active");
				var oldTabContent = $this.find(".tab-contents.active");
				var direction = null;				
				if (!$(this).is(".active") && oldTab.length > 0 && oldTabContent.length > 0) {
					if (oldTab.index() > $(this).index()) {
						direction = "right";						
					} else {
						direction = "left";
					}					
				}
				var tabId = $(this).attr("data-id");
				$this.find(".tabs a").not(this).removeClass("active");				
				$(this).addClass("active");
				$this.find(".contents").find(".tab-contents").not("[data-id='" + tabId + "']").removeClass("active").addClass("inactive");				
				
				var newTabContent =
					$this.find(".contents").find(".tab-contents[data-id='" + tabId + "']").addClass("active").removeClass("inactive");

				if (direction && $this.is(".with-animations")) {
					addAnimationHelper(oldTabContent, newTabContent, direction);
				}

				if ($(window).scrollTop() > $this.offset().top + $this.outerHeight()) {
					$(window).scrollTop($this.offset().top);
				}

				return false;
			});

			$this.find(".tabs a.active").click();			

			// Sticky header
			if ($this.is(".sticky-header")) {
				$(window).scroll(function() {
					checkStickyStatus();
				});
				checkStickyStatus();
			}

			function addAnimationHelper(tabContent, $newTabContent, direction) {
				var $helper = $(tabContent).clone();
				$helper.attr("id", "");
				$helper.removeClass("inactive").addClass("helper-contents");
				$this.find(".contents").append($helper);
				$newTabContent.addClass("appearing").addClass(direction);
				window.setTimeout(function() {
					$helper.addClass(direction);					
					$newTabContent.removeClass("appearing left right");
				}, 50);
				window.setTimeout(function() {
					$helper.slideUp(300, function() {
						$helper.remove();	
					});
				}, 1000);
			}

			function checkStickyStatus() {
				if ($this.offset().top - thisHeight < $(window).scrollTop()) {
					$this.addClass("sticked");
				} else {
					$this.removeClass("sticked");
				}
			}			

		});

	};

})(jQuery);